import { TextField } from "@mui/material";

interface Props {
	label: string;
	value: string | number;
	width?: number;
}

// A value the user reads but does not edit: the field shape of its neighbours, white,
// with no blue outline on focus so it does not pass for an input (same as Rolls Received).
export const ReadOnlyField = ({ label, value, width = 110 }: Props) => (
	<TextField
		label={label}
		value={value === "" ? "-" : value}
		size="small"
		slotProps={{
			inputLabel: { shrink: true },
			input: { readOnly: true },
			htmlInput: { tabIndex: -1, style: { textAlign: "center" } },
		}}
		sx={{
			width,
			"& .MuiOutlinedInput-root": {
				"& fieldset": { borderColor: "divider", borderWidth: 1 },
				"&:hover fieldset": { borderColor: "divider", borderWidth: 1 },
				"&.Mui-focused fieldset": { borderColor: "divider", borderWidth: 1 },
			},
			"& .MuiInputBase-input": { cursor: "default" },
		}}
	/>
);
